import { Component  } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NavController, NavParams, ToastController } from "ionic-angular";
import { AlertController, LoadingController } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import { Status } from "../../models/interfaces/status.model";
import { AuthService } from "../../providers/dbservice/authservice";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";
import { ValidationserviceProvider } from "../../providers/dbservice/validationservice";
import { ConfigService } from '../../providers/dbservice/configservice';

@Component({
  selector: "page-expenses_update",
  templateUrl: "expenses_update.html",
})

export class ExpensesUpdatePage {
  private settings$: any;
  private loading: any;
  private expensesForm: FormGroup;

  private setting: any;
  private hl_id: number;
  private ex_amount: number;
  private ex_rate: number;
  private ex_qty: number;
  private ex_id: number;
  private se_order: number;
  private styleName: string ="";
  private ex_date: string = new Date(new Date().getFullYear(), new Date().getMonth() , new Date().getDate() + 1).toISOString().substring(0, 10);

  constructor(private configService: ConfigService,public authService: AuthService, public navCtrl: NavController, public navParams: NavParams,
    private formBuilder: FormBuilder, private toastCtrl: ToastController,
    private db: DbserviceProvider, public alertCtrl: AlertController, public loadingCtrl: LoadingController,
  ) {
    console.log("ExpensesUpdatePage constructor", this.navParams);
    this.styleName=this.configService.getConfig("STYLENAME");
    this.hl_id = this.navParams.data.expenses.hl_id ;
    this.ex_id = this.navParams.data.expenses.ex_id ;
    this.ex_date = this.navParams.data.expenses.ex_date ;
    this.ex_qty = this.navParams.data.expenses.ex_qty ;
    this.ex_rate = this.navParams.data.expenses.ex_rate ;
    this.se_order = this.navParams.data.expenses.se_order ;
    
    this.expensesForm = this.formBuilder.group({
      "se_id": [this.navParams.data.expenses.se_id, [Validators.required]],
      "se_order": [this.navParams.data.expenses.se_order],
      "ex_date": [this.navParams.data.expenses.ex_date, [Validators.required]],
      "hl_id": [this.navParams.data.expenses.hl_id],
      "ex_remark": [this.navParams.data.expenses.ex_remark],
      "ex_qty": [+this.navParams.data.expenses.ex_qty],
      "ex_rate": [this.navParams.data.expenses.ex_rate],
      "ex_amount": [this.navParams.data.expenses.ex_amount],
    });
  }
  private ionViewWillEnter() {
    console.log("ExpensesUpdatePage ionViewWillEnter");
    this.onInitPage();
  }

  private onInitPage() {
    console.log("ExpensesUpdatePage onInitPage");

    this.db.dbCol({
      "action": "select", "mapObject": "settings",
      "sqlExtended": " where se_class='Expenses' order by se_order",
    }).subscribe((ret) => {
      this.settings$ = ret;
    });
  }

  private onInput_ex_qty(_ex_qty) {
    console.log("ExpensesAddPage onInput_pl_qty");
    this.ex_qty = _ex_qty;
    this.ex_amount = this.ex_rate * this.ex_qty;
  }

  private changeSelect_item(_se_id) {
    console.log("ExpensesUpdatePage changeSelect_se_name");

    this.setting = this.settings$.filter(
      (setting) => setting.se_id === _se_id);
    this.se_order = this.setting[0].se_order;
    this.ex_rate = this.setting[0].se_key_value;
    this.ex_amount = this.setting[0].se_key_value * this.ex_qty;
  }

  private goback() {
    console.log("ExpensesUpdatePage goback");
    this.navCtrl.pop();
  }

  private updateExpenses(value: any) {
    console.log("ExpensesUpdatePage updateExpenses");

    const formValues: any = {
      "ex_amount": value.ex_amount,
      "ex_date": value.ex_date,
      "ex_id": this.ex_id,
      "ex_qty": value.ex_qty,
      "ex_rate": value.ex_rate,
      "ex_remark": value.ex_remark,
      "hl_id": this.hl_id,
      "se_id": value.se_id,
      "se_order": this.se_order,
    };

     this.db.dbCol({ "action": "update", "mapObject": "expenses", ...formValues })
      .subscribe((ret) => {
        this.navCtrl.pop();
      },
    );
  }

  private ngOnDestroy() {
    console.log("ExpensesAddPage ngOnDestroy");
  }
}



// WEBPACK FOOTER //
// ./src/pages/expenses/expenses_update.ts